/* eslint-disable react/jsx-no-useless-fragment */
import React, { ReactNode, Fragment } from 'react';
import locale from '@glu/locale';

const paramRegex = /{\d+}/g;

export interface ILocaleProps {
  /** The locale key to render */
  localeKey: string;
  /** Any parameters to render into the locale */
  params?: ReactNode[];
}

const emptyArr = [] as ReactNode[];
const Locale = ({ localeKey, params = emptyArr }: ILocaleProps) => {
  const localeString = locale.get(localeKey);

  if (!params.length) {
    return <>{localeString}</>;
  }

  const matches = localeString.match(paramRegex);
  const staticParts = localeString.split(paramRegex);

  if (!matches) return <>{localeString}</>;

  return (
    <>
      {staticParts.reduce<ReactNode[]>((memo, value, index) => {
        const match = matches[index];
        const paramIndex = parseInt(match?.substring(1, match.length - 1), 10);
        const param = params[paramIndex];

        return [
          ...memo,
          <Fragment key={`${value}-0`}>{value}</Fragment>,
          match ? (
            <Fragment key={`${value}-1`}>{param === undefined ? match : param}</Fragment>
          ) : null,
        ].filter(Boolean);
      }, [])}
    </>
  );
};

export default Locale;
